import * as Sentry from '@sentry/react';

// Sentry-Fehler-Monitoring (Partner-Portal). Ohne REACT_APP_SENTRY_DSN bleibt es still (no-op).
// DSGVO-Guard: nur EU-Datenregion (*.ingest.de.sentry.io) — ein US-DSN würde
// Fehlerdaten in die USA senden und wird deshalb verweigert (Konsole statt Versand).
function euOk(d) {
  try { return new URL(d).host.endsWith('.ingest.de.sentry.io'); } catch { return false; }
}

const dsn = process.env.REACT_APP_SENTRY_DSN;
if (dsn && !euOk(dsn)) {
  // eslint-disable-next-line no-console
  console.error('Sentry verweigert: DSN ist keine EU-Datenregion (*.ingest.de.sentry.io) — kein Versand (DSGVO).');
} else if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.NODE_ENV,
    // DSGVO: keine personenbezogenen Daten (IP) an Sentry senden.
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    // Gemeinsames Web-Projekt: nach App filterbar (admin vs partner).
    initialScope: { tags: { app: 'partner' } },
  });
}
